module.exports = __webpack_public_path__ + "img/4.317d41cd.jpg";